import React from "react";
import { LeaveSectionData } from "../../data/sections/LeaveSectionData";

const Leave = ({ country }) => {
  const fetchLeaveData = country
    ? LeaveSectionData.countries.find(
        (c) =>
          c.country.replace(/\s+/g, "-").toLowerCase() ===
          country.replace(/\s+/g, "-").toLowerCase()
      )
    : null;

  if (!fetchLeaveData) {
    return <p>Country not found or data not available.</p>;
  }

  return (
    <div className="leave-section">
      <h3>Leave</h3>

      {Object.entries(fetchLeaveData.details).map(([key, value], index) => (
        <div key={index} className="leave-section-item">
          {key === "public_holidays" ? (
            // Render Public Holidays as a table
            <>
              <h6>{formatKey(key)}</h6>
              <p>{value.description}</p>
              <table className="holiday-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Day</th>
                    <th>Holiday</th>
                  </tr>
                </thead>
                <tbody>
                  {value.holidays.map((holiday, idx) => (
                    <tr key={idx}>
                      <td>{holiday.date}</td>
                      <td>{holiday.day}</td>
                      <td>{holiday.holiday}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : (
            // Render other details as a list
            <>
              <h6>{formatKey(key)}</h6>
              {Object.entries(value).map(([innerKey, innerValue], idx) => (
                <p key={idx}>
                  <span>{formatKey(innerKey)}:</span> {formatValue(innerValue)}
                </p>
              ))}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

// Utility function to format keys
const formatKey = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

// Utility function to format values
const formatValue = (value) => {
  if (Array.isArray(value)) {
    // Render array as a list
    return (
      <ul>
        {value.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    );
  }

  return value;
};

export default Leave;
